export default class EncorePlugin {
	static install(Vue, options) {
		Vue.mixin({
			methods: {

				//use the asset handler for asset handling (outside webpack)
				asset(url) {
					return url
				}
			}
		})
	}
}